import React from "react";
import {
    BulkWorkflowOperation,
    BulkWorkflowOperationConfig
} from "src/components/common/bulk-workflow-operation";
import {
    clientId,
    recipeId,
    program,
    BULK_RESTART_CSV_MAX_ROWS,
    SAMPLE_BULK_RESTART_RECORDS_INPUT,
    SAMPLE_BULK_RESTART_RECORDS_INPUT_FILE,
    BULK_RESTART_README_INSTRUCTIONS,
    BULK_RESTART_README_COLUMN_SCHEMA,
    BULK_RESTART_FILE_EXAMPLE,
    BULK_RESTART_OUTPUT_EXAMPLE,
    BULK_RESTART_RESULT_TEXT
} from "src/constants/restart-workflow-instance";

const bulkRestartConfig: BulkWorkflowOperationConfig = {
    operationType: 'restart',
    operationDisplayName: 'Restart',
    clientId,
    recipeId,
    program,
    maxRows: BULK_RESTART_CSV_MAX_ROWS,
    sampleInput: SAMPLE_BULK_RESTART_RECORDS_INPUT,
    sampleInputFileName: SAMPLE_BULK_RESTART_RECORDS_INPUT_FILE,
    readmeInstructions: BULK_RESTART_README_INSTRUCTIONS,
    readmeColumnSchema: BULK_RESTART_README_COLUMN_SCHEMA,
    fileExample: BULK_RESTART_FILE_EXAMPLE,
    outputExample: BULK_RESTART_OUTPUT_EXAMPLE,
    resultText: BULK_RESTART_RESULT_TEXT
};

export function BulkRestartWorkflowInstance() {
    return <BulkWorkflowOperation config={bulkRestartConfig} />;
}